import './css/index.scss';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import router from './pages/router';
import AppLoader from 'components/AppLoader';
import { CommunicationProvider } from 'components/communication';
import { TextsProvider } from 'components/texts';
import { ActivitiesMetadataProvider } from 'features/metadata/components';
import { ModalsContextProvider } from 'components/design/modals';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CommunicationProvider>
      <TextsProvider>
        <AppLoader>
          <ActivitiesMetadataProvider>
            <ModalsContextProvider>
              <RouterProvider router={router} />
            </ModalsContextProvider>
          </ActivitiesMetadataProvider>
        </AppLoader>
      </TextsProvider>
    </CommunicationProvider>
  </StrictMode>,
);
